import { api } from "../integradorcontabilidad/ApiConfiguracionIntegradorContabilidad"

export const CamposApi =  {
    getCamposId:function(id: number)
    {
        return api.get(`/api/campos/${id}`)
    },
}